export enum WsEventType {
	// Notifications
	RefreshUserNotifications = 'RefreshUserNotifications',

}
